import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "scenario-preview-header"
}
const _hoisted_2 = {
  key: 1,
  class: "rubric-dynamicform-instructions"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "rubric-dynamicform-instructions"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "rubric-dynamicform-instructions"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "row px-3" }
const _hoisted_12 = {
  key: 0,
  class: "card mb-4 shadow-sm w-100"
}
const _hoisted_13 = { class: "card-header bg-secondary text-white fw-bold" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "radio-custom" }
const _hoisted_18 = ["id", "name", "value", "onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "radio-custom" }
const _hoisted_21 = ["id", "name", "value", "onClick"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = ["name", "onInput"]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = {
  class: "btn-group btn-group-toggle float-end",
  "data-toggle": "buttons"
}
const _hoisted_30 = ["for"]
const _hoisted_31 = ["id", "name", "value"]
const _hoisted_32 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_alert = _resolveComponent("error-alert")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.instructions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", { innerHTML: _ctx.instructions }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.formQuestions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.learner_instructions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Learner Instructions:", -1)),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("span", { innerHTML: _ctx.learner_instructions }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (_ctx.scorer_instructions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Scorer Instructions:", -1)),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("span", { innerHTML: _ctx.scorer_instructions }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formQuestions, (question_set, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12",
              key: key
            }, [
              (question_set.name !== null)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    innerHTML: question_set.name,
                    class: "col-12 text-center"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              (question_set.instructions !== null)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: question_set.instructions,
                    class: "col-12 px-5 pt-1 pb-4 text-center fw-bold"
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question_set, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-12 col-md-6 col-lg-6",
                    key: index
                  }, [
                    (index !== 'instructions' && index !== 'name' && index !== 'display_type')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, "Question " + _toDisplayString(parseInt(index) + 1), 1),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", {
                              innerHTML: item.question
                            }, null, 8, _hoisted_15),
                            _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
                            (item.question_type_id == _ctx.QuestionType.MULTIPLECHOICE)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answers, (answer) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: answer.id
                                    }, [
                                      _createElementVNode("label", _hoisted_17, [
                                        _createElementVNode("span", null, _toDisplayString(answer.answer), 1),
                                        _createElementVNode("input", {
                                          type: "radio",
                                          id: answer.id,
                                          name: item.id,
                                          value: answer.id,
                                          onClick: ($event: any) => (_ctx.clearError('error_'+item.id))
                                        }, null, 8, _hoisted_18),
                                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (item.question_type_id == _ctx.QuestionType.TRUEFALSE)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answers, (answer) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: answer.id
                                    }, [
                                      _createElementVNode("label", _hoisted_20, [
                                        _createElementVNode("span", null, _toDisplayString(answer.answer), 1),
                                        _createElementVNode("input", {
                                          type: "radio",
                                          id: answer.id,
                                          name: item.id,
                                          value: answer.id,
                                          onClick: ($event: any) => (_ctx.clearError('error_'+item.id))
                                        }, null, 8, _hoisted_21),
                                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (item.question_type_id == _ctx.QuestionType.LONGFILL)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("textarea", {
                                    class: "w-100",
                                    name: item.id,
                                    onInput: ($event: any) => (_ctx.clearError('error_'+item.id))
                                  }, null, 40, _hoisted_23)
                                ]))
                              : _createCommentVNode("", true),
                            (item.question_type_id == _ctx.QuestionType.LIKERT)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("small", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answers, (answer, index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: answer.id
                                          }, [
                                            _createTextVNode(_toDisplayString(index + 1) + " = " + _toDisplayString(answer.answer), 1),
                                            (index !== 4)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, ", "))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answers, (answer, index) => {
                                          return (_openBlock(), _createElementBlock("label", {
                                            key: answer.id,
                                            class: _normalizeClass('p-3 btn btn-light btn_ques_' + item.id),
                                            for: 'ans_' + answer.id
                                          }, [
                                            _createElementVNode("input", {
                                              class: "btn-check",
                                              type: "radio",
                                              id: 'ans_' + answer.id,
                                              name: item.id,
                                              value: answer.id,
                                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.buttonUpdate && _ctx.buttonUpdate(...args)))
                                            }, null, 8, _hoisted_31),
                                            _createTextVNode(_toDisplayString(index + 1), 1)
                                          ], 10, _hoisted_30))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_error_alert, {
                              elm_id: 'error_'+item.id
                            }, null, 8, ["elm_id"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "w-75" }, null, -1))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "card-body" }, " There are currently no questions. Select an existing rubric from the drop-down or click the \"+ Create Question\" button to create new questions. ", -1)
        ])))
  ]))
}